import GlobalHeader from "components/v2/global-header/GlobalHeader";
import useDesktopChecker from "hooks/useDesktopChecker";
import GlobalOuterLayout from "../global-outer-layout/GlobalOuterLayout";
import SideBar from "components/v2/sidebar/SideBar";
import Application from "pages/application/Application";
import { getStepData } from "pages/application/question/questionSlice";
import { useSelector } from "react-redux";
import SectionBar from "components/v2/section-bar/SectionBar";
import { NotificationProvider } from "contexts/NotificationContext";

export const ApplicationSharedLayoutContent = () => {
    const isDesktop = useDesktopChecker();
    const { section: activeSection, sections } = useSelector(getStepData);
    return (
        <GlobalOuterLayout>
            {isDesktop && (
                <div className="application-layout-context">
                    <SideBar>
                        <SectionBar activeSection={activeSection} sections={sections} />
                    </SideBar>
                    <div className="global-outer-layout__wrapper">
                        <GlobalHeader />
                        <Application />
                    </div>
                </div>
            )}
            {!isDesktop && (
                <div className="mobile-container">
                    <GlobalHeader />
                    <Application />
                </div>
            )}
        </GlobalOuterLayout>
    );

};

export const ApplicationSharedLayout = () => {
  return (
    <NotificationProvider enabled={false}>
      <ApplicationSharedLayoutContent />
    </NotificationProvider>
  );
};

export default ApplicationSharedLayout;
